<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>
      {{ labelService.getLabel("Errore") }}
    </h2>

    <span>{{ errorMessage }}</span>

    <div class="panel-buttons">
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('cancel')"
        (click)="onClose()"
      ></app-button>
    </div>
  </div>
</div>
